import User from '@/generated/classes/User';
import { storeSession } from '@/generated/stores';
import UserProfile from "@/framework/base/classes/UserProfile";

export default class UserExtend  extends User {
  constructor() {
    super();
  }

  public static isSupport (): boolean {
    let res = false;
    const user = storeSession.connectedUser
    if (user && user.id > 0) {
      res = (user.currentProfil & UserProfile.userInterne) > 0;
    }
    return res;
  }

}
